// RelevantPersonDetails.jsx (Compact / Matching UI)

import React, { useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Controller } from "react-hook-form";

const titleOptions = [
  "Mr",
  "Mrs",
  "Miss",
  "Ms",
  "Mx",
  "Dr",
  "Prof",
  "Sir",
  "Dame",
  "N/A",
];

const inputStyle = {
  backgroundColor: "#fff",
  borderRadius: "10px",
};

const RelevantPersonDetails = ({ control, errors ,reset,payload}) => {
  useEffect(() => {
    if (payload?.relativePersonDetails) {
      reset(payload.relativePersonDetails);   // ← PERFECT
    }
  }, [payload]);
  return (
    <Box sx={{ width: "100%", pb: 2 }}>
      <Typography
        sx={{
          fontWeight: 700,
          mb: 2,
          color: "#444",
          fontSize: "20px",
        }}
      >
        Relevant Person Details
      </Typography>

      <Grid container spacing={2}>
        {/* TITLE */}
        <Grid item xs={12}>
          <FormControl fullWidth size="small" error={!!errors.title}>
            <InputLabel>Title</InputLabel>

            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  label="Title"
                  sx={inputStyle}
                >
                  {titleOptions.map((t) => (
                    <MenuItem key={t} value={t}>
                      {t}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>

          {errors.title && (
            <Typography
              color="error"
              sx={{ fontSize: "12px", mt: 0.5 }}
            >
              {errors.title.message}
            </Typography>
          )}
        </Grid>

        {/* FIRST NAME */}
        <Grid item xs={12} sm={6}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="First Name"
                sx={inputStyle}
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            )}
          />
        </Grid>

        {/* SURNAME */}
        <Grid item xs={12} sm={6}>
          <Controller
            name="surname"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Surname"
                sx={inputStyle}
                error={!!errors.surname}
                helperText={errors.surname?.message}
              />
            )}
          />
        </Grid>

        {/* EMAIL */}
        <Grid item xs={12}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Email Address"
                sx={inputStyle}
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            )}
          />
        </Grid>

        {/* CODE */}
        <Grid item xs={12} sm={4}>
          <Controller
            name="code"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Code"
                placeholder="+44"
                sx={inputStyle}
                error={!!errors.code}
                helperText={errors.code?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={8}>
  <Controller
    name="phone"
    control={control}
    render={({ field }) => (
      <TextField
        {...field}
        fullWidth
        size="small"
        label="Contact Number"
        sx={inputStyle}
        error={!!errors.phone}
        helperText={errors.phone?.message}
        inputProps={{
          inputMode: "numeric",
          pattern: "[0-9]*"
        }}
        onChange={(e) => {
          const value = e.target.value.replace(/[^0-9]/g, "");
          field.onChange(value);
        }}
      />
    )}
  />
</Grid>

        {/* ADDRESS */}
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "14px",
              mb: 0.5,
              color: "#333",
            }}
          >
            Contact Address
          </Typography>

          <Controller
            name="address"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                placeholder="Start typing an address..."
                sx={inputStyle}
                error={!!errors.address}
                helperText={errors.address?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RelevantPersonDetails;
